module.exports = __webpack_public_path__ + "img/maison9.0ebd8722.jpg";